import { createMemoryHistory } from 'history';

// Using memory history to avoid changing browser's url
const history = createMemoryHistory();

export default history;
